import SvgIconCheckmark from '@/common/icons/generated/common/IconCheckmark';

import styles from './ToastNotification.module.scss';

interface ToastNotificationProps {
  routeUrl?: string;
  text: string;
}

export const ToastNotification = ({ routeUrl, text }: ToastNotificationProps) => {
  return (
    <div className={styles.toastNotificationContainer}>
      <SvgIconCheckmark className={styles.toastIcon} />
      <p className={styles.toastText}>{text}</p>
      {routeUrl ? (
        <a className={styles.toastLink} href={routeUrl}>
          Show
        </a>
      ) : null}
    </div>
  );
};
